import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense } from "react";
import Section from "../Section";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { useAppLoad } from "../../appLoadContext";
import { DployTable, ErrorPageContent } from "@ploy-ui/core";
import { useResource } from "@rest-hooks/core";
import { ApplicationFormalitiesResource } from "@ploy-lib/rest-resources";
import { ErrorHandler } from "@ploy-lib/core";
addRegisteredSectionLayout({
    name: "FormalityControlSection",
    displayName: "FormalityControlSection",
    settings: {}
});
const useStyles = makeStyles((theme) => ({
    root: {
        headerMarginTop: theme.spacing(1)
    }
}), { name: "DployFormSection" });
const columns = [
    {
        field: "key",
        title: (_jsx(FormattedMessage, { id: "dploy.formalitiyControlSection.key.header", defaultMessage: "Checkpoint group" })),
        render: data => _jsx(Typography, { variant: "body2", children: data.key })
    },
    {
        field: "checkpoint",
        title: (_jsxs(Grid, { container: true, style: { justifyContent: "space-between" }, children: [_jsx(Grid, { item: true, children: _jsx(FormattedMessage, { id: "dploy.formalitiyControlSection.checkpoint.header", defaultMessage: "Checkpoint" }) }), _jsx(Grid, { item: true, children: _jsx(FormattedMessage, { id: "dploy.formalitiyControlSection.checkpoint.date", defaultMessage: "Date Done" }) })] })),
        render: data => (_jsx(Grid, { item: true, container: true, children: data.checkpoints.map(checkpoint => (_jsxs(Grid, { item: true, container: true, alignItems: "center", style: {
                    justifyContent: "space-between",
                    color: checkpoint.checkItem ? "inherit" : "red"
                }, children: [_jsx(Typography, { variant: "body2", children: checkpoint.formalitiesCheckName }), _jsx(Typography, { variant: "body2", children: checkpoint.checkItem ? (checkpoint.originalCheckedDate) : (_jsx(FormattedMessage, { id: "dploy.formalityControlSection.checkpoint.missing", defaultMessage: "Not executed" })) })] }, checkpoint.formalitiesCheckId))) }))
    }
];
const FormalityControlSectionInternal = (props) => {
    const sectionClasses = useStyles(props);
    const { className, onClick, fields } = props;
    const { applicationNumber } = useAppLoad();
    const formalities = useResource(ApplicationFormalitiesResource.list(), {
        applicationNumber: applicationNumber
    });
    return (_jsx("div", { className: className, onClick: onClick, children: _jsxs(Suspense, { fallback: null, children: [_jsx(DployTable, { columns: columns, data: formalities.map(f => ({ ...f, id: f.pk() })), listCellsBreakpoint: "xs", options: {
                        search: false,
                        grouping: false,
                        showEmptyDataSourceMessage: false,
                        emptyRowsWhenPaging: false,
                        paging: false,
                        header: true,
                        toolbar: false,
                        sorting: false,
                        draggable: false
                    } }), _jsx(Section, { className: sectionClasses.root, ...fields, ...props })] }) }));
};
const FormalityControlSection = (props) => (_jsx(ErrorHandler, { fallback: e => (_jsx(ErrorPageContent, { className: props.className, onClick: props.onClick, header: _jsxs("span", { children: [FormalityControlSection.displayName, " failed to render."] }) })), children: _jsx(FormalityControlSectionInternal, { ...props }) }));
FormalityControlSection.displayName = "DployFormalityControlSection";
export { FormalityControlSection };
//# sourceMappingURL=FormalityControlSection.js.map